import type { IHistoricoPedidoItem } from "interfaces/loja/pedidoHistorico";

export type PosVendaTipo = "TROCA" | "DEVOLUCAO";

export type PosVendaInfo = {
  tipo: PosVendaTipo | null;
  motivo: string | null;
  protocolo: string | null;
  createdAt: string | null;
  origemCliente: boolean;
};

function parseDescricaoPosVenda(desc: string): {
  tipo: PosVendaTipo | null;
  motivo: string | null;
  protocolo: string | null;
} {
  const tipoMatch = desc.match(/^\[(TROCA|DEVOLUCAO)\]/);
  const tipo = (tipoMatch?.[1] as PosVendaTipo | undefined) ?? null;
  const protocoloMatch = desc.match(/Protocolo:\s*(PV-[^\s|]+)/i);
  const motivoMatch = desc.match(
    /^\[(?:TROCA|DEVOLUCAO)\]\s*(.+?)(?:\s*\|\s*Protocolo:|$)/,
  );
  return {
    tipo,
    motivo: motivoMatch?.[1]?.trim() ?? null,
    protocolo: protocoloMatch?.[1]?.trim() ?? null,
  };
}

/** Extrai solicitação pós-venda do histórico do pedido (cliente ou admin). */
export function extrairPosVendaDoHistorico(
  historico?: IHistoricoPedidoItem[] | null,
): PosVendaInfo | null {
  if (!Array.isArray(historico) || historico.length === 0) return null;

  const posVendaCliente = [...historico]
    .filter((h) => h.acao === "POS_VENDA_SOLICITADA")
    .sort(
      (a, b) =>
        new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime(),
    )[0];

  if (posVendaCliente) {
    const parsed = parseDescricaoPosVenda(String(posVendaCliente.descricao ?? ""));
    return {
      ...parsed,
      createdAt: posVendaCliente.createdAt,
      origemCliente: true,
    };
  }

  const devolucaoAdmin = [...historico]
    .filter((h) => h.acao === "DEVOLUCAO_SOLICITADA")
    .sort(
      (a, b) =>
        new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime(),
    )[0];

  if (!devolucaoAdmin) return null;

  const desc = String(devolucaoAdmin.descricao ?? "");
  const parsed = parseDescricaoPosVenda(desc);

  return {
    tipo: parsed.tipo,
    motivo: parsed.motivo ?? (desc.replace(/^Solicitação de devolução:\s*/i, "").trim() || null),
    protocolo: parsed.protocolo,
    createdAt: devolucaoAdmin.createdAt,
    origemCliente: false,
  };
}

export function labelTipoPosVenda(tipo: PosVendaTipo | null): string {
  if (tipo === "TROCA") return "Troca solicitada";
  if (tipo === "DEVOLUCAO") return "Devolução solicitada";
  return "Devolução solicitada";
}
